import cloneDeep from 'lodash/cloneDeep';

import { IDailySchedule, IRawSchedule } from '../../models';
import { getModifiedHoursIfEmpty } from './get-modified-hours-if-empty';

export function fromBackendFormatDay(schedule: IDailySchedule): Array<Array<IRawSchedule & string>> {
  const {closed, nextDay, hours: scheduleHours, publicDisabled} = cloneDeep(schedule);
  let hours = closed ? [[]] : getModifiedHoursIfEmpty(scheduleHours);

  if (nextDay) {
    //max count is 2
    let count = hours.length - 1;
    hours = hours.map((hoursSet, i) => {
      if (i === count) {
        let _count = hoursSet.length - 1;

        return hoursSet.map((slotValue, j) => {
          if (j === _count) {
            slotValue.addOneDay = true;
          }

          return slotValue;
        });
      }

      return hoursSet;
    })
  }
  return hours;
}
